import type { LensDefinition } from '../models/explorer/ExplorerLens';
import {
  iconForCategory,
  resolveCategoryForNode,
} from './providerIcons';

/**
 * P1.4a — Azure icon lens. Mirrors the AWS lens against the Azure
 * service → category map. Useful on folders that federate an Azure
 * scan or a multi-cloud graph.
 */
export const azureIconLens: LensDefinition = {
  id: 'azure-icons',
  label: 'Azure icons',
  description: 'Provider-icon view — colours resources by Azure service category.',

  decorate(node) {
    const props = (node.props ?? {}) as Record<string, unknown>;
    const manifestId =
      (props._manifestId as string | undefined) ??
      (props.manifestId as string | undefined) ??
      node.type;
    const category = resolveCategoryForNode('azure', manifestId);
    if (!category) {
      return {
        dataMissing: true,
        badge: { label: 'unknown service', tone: 'neutral' },
      };
    }
    return {
      icon: iconForCategory(category),
      badge: { label: category, tone: 'neutral' },
    };
  },
};
